import ApiService from "@/core/services/api.service";

export const FETCH_SERVICE_VISITS = "fetchServiceVisits";
export const FETCH_SERVICE_VISITS_BOARD = "fetchServiceVisitsBoard";
export const FETCH_SERVICE_VISIT = "fetchServiceVisit";
export const FETCH_SERVICE_VISIT_STATUSES = "fetchServiceVisitStatuses";
export const FETCH_SERVICE_VISIT_ITEM_STATUSES = "fetchServiceVisitItemStatuses";
export const FETCH_SERVICE_VISIT_PRIORITIES = "fetchServiceVisitPriorities";
export const FETCH_SERVICE_VISIT_SERVICE_LOCATIONS =
  "fetchServiceVisitServiceLocations";
export const FETCH_SERVICE_VISIT_MECHANICS = "fetchServiceVisitMechanics";
export const FETCH_SERVICE_VISIT_SERVICE_TYPES = "fetchServiceVisitServiceTypes";
export const FETCH_SERVICE_VISIT_MACHINE_SERVICE_SIGNALS =
  "fetchServiceVisitMachineServiceSignals";
export const SAVE_SERVICE_VISIT = "saveServiceVisit";
export const UPDATE_SERVICE_VISIT = "updateServiceVisit";
export const CREATE_SERVICE_VISIT_TASK_ITEM = "createServiceVisitTaskItem";
export const UPDATE_SERVICE_VISIT_TASK_ITEM = "updateServiceVisitTaskItem";
export const REORDER_SERVICE_VISIT_TASK_ITEMS = "reorderServiceVisitTaskItems";
export const MOVE_SERVICE_VISIT_BOARD_CARD = "moveServiceVisitBoardCard";
export const DELETE_SERVICE_VISIT = "deleteServiceVisit";
export const CREATE_SERVICE_VISIT_COMMENT_FOR_VISIT =
  "createServiceVisitCommentForVisit";
export const UPDATE_SERVICE_VISIT_COMMENT_FOR_VISIT =
  "updateServiceVisitCommentForVisit";
export const DELETE_SERVICE_VISIT_COMMENT_FOR_VISIT =
  "deleteServiceVisitCommentForVisit";

export const SET_ERROR = "setServiceVisitError";
export const SET_LOADING = "setLoadingServiceVisit";

const state = {
  errors: [],
  isLoadingServiceVisit: false
};

const getters = {
  isLoadingServiceVisit() {
    return state.isLoadingServiceVisit;
  }
};

const actions = {
  [FETCH_SERVICE_VISITS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("service-visits" + apiParams)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response))
        .finally(() => context.commit(SET_LOADING, false));
    });
  },
  [FETCH_SERVICE_VISITS_BOARD](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("service-visits/board" + apiParams)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response))
        .finally(() => context.commit(SET_LOADING, false));
    });
  },
  [FETCH_SERVICE_VISIT](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("service-visits", id)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response))
        .finally(() => context.commit(SET_LOADING, false));
    });
  },
  [FETCH_SERVICE_VISIT_STATUSES]() {
    return new Promise((resolve, reject) => {
      ApiService.get("service-visit-statuses/options")
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },
  [FETCH_SERVICE_VISIT_ITEM_STATUSES]() {
    return new Promise((resolve, reject) => {
      ApiService.get("service-visit-item-statuses/options")
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },
  [FETCH_SERVICE_VISIT_PRIORITIES]() {
    return new Promise((resolve, reject) => {
      ApiService.get("service-visit-priorities/options")
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },
  [FETCH_SERVICE_VISIT_SERVICE_LOCATIONS]() {
    return new Promise((resolve, reject) => {
      ApiService.get("service-locations/options")
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },
  [FETCH_SERVICE_VISIT_MECHANICS](context, apiParams = "") {
    return new Promise((resolve, reject) => {
      ApiService.get("mechanics" + apiParams)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },
  [FETCH_SERVICE_VISIT_SERVICE_TYPES](context, apiParams = "") {
    return new Promise((resolve, reject) => {
      ApiService.get("service-types/options" + apiParams)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },
  [FETCH_SERVICE_VISIT_MACHINE_SERVICE_SIGNALS](context, apiParams = "") {
    return new Promise((resolve, reject) => {
      ApiService.get("machine-service-signals/options" + apiParams)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },
  [SAVE_SERVICE_VISIT](context, payload) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.post("service-visits", payload)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response))
        .finally(() => context.commit(SET_LOADING, false));
    });
  },
  [UPDATE_SERVICE_VISIT](context, params) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.update("service-visits", params.id, params.payload)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response))
        .finally(() => context.commit(SET_LOADING, false));
    });
  },
  [UPDATE_SERVICE_VISIT_TASK_ITEM](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.put(`service-visit-items/${params.itemId}`, params.payload)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },
  [CREATE_SERVICE_VISIT_TASK_ITEM](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(`service-visits/${params.visitId}/items`, params.payload)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },
  [REORDER_SERVICE_VISIT_TASK_ITEMS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.put(`service-visits/${params.visitId}/items/reorder`, params.payload)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },
  [MOVE_SERVICE_VISIT_BOARD_CARD](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put("service-visits/board/move", payload)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },
  [DELETE_SERVICE_VISIT](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("service-visits", id)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response))
        .finally(() => context.commit(SET_LOADING, false));
    });
  },
  [CREATE_SERVICE_VISIT_COMMENT_FOR_VISIT](context, params) {
    return ApiService.post(`service-visits/${params.visitId}/comments`, params.payload)
      .then(({ data }) => data)
      .catch(({ response }) => Promise.reject(response));
  },
  [UPDATE_SERVICE_VISIT_COMMENT_FOR_VISIT](context, params) {
    return ApiService.put(`service-visits/${params.visitId}/comments/${params.commentId}`, params.payload)
      .then(({ data }) => data)
      .catch(({ response }) => Promise.reject(response));
  },
  [DELETE_SERVICE_VISIT_COMMENT_FOR_VISIT](context, params) {
    return ApiService.delete(`service-visits/${params.visitId}/comments`, params.commentId)
      .then(({ data }) => data)
      .catch(({ response }) => Promise.reject(response));
  },
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingServiceVisit = false;
    state.errors = Array.isArray(errors) ? errors : [errors];
  },
  [SET_LOADING](state, value) {
    state.isLoadingServiceVisit = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
